<script lang="ts">
  // we only replace the email in a template. TODO switch to Snippet
  /* eslint svelte/no-at-html-tags: "off" */

  import type { SubscriptionConfig } from '@/teoCore/TeoApi';
  import VStack from '@/ui/base/stack/VStack.svelte';
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import LinkButton from '@/ui/elements/buttons/LinkButton.svelte';
  import DropDownLogin from '@/ui/elements/dropdown/DropDownLogin.svelte';
  import TextInput from '@/ui/elements/text-input/TextInput.svelte';

  import { useLoginForm } from './useLoginForm.svelte';

  let { config }: { config: SubscriptionConfig } = $props();

  let [form, formActions] = useLoginForm({ config });
</script>

<VStack class="w-[320px]" gap={8}>
  <VStack gap={3} xalign="center">
    <h1 class="text-title font-semibold">{form.labels.title}</h1>
    <p class="text-center">{@html form.labels.subtitle}</p>
  </VStack>

  <form onsubmit={formActions.submit}>
    <VStack gap={8}>
      <VStack gap={2} xalign="end">
        {#if form.showUserInputTypeToggle}
          <LinkButton highlight type="button" onclick={() => formActions.toggleUserInputType()}
            >{form.currentUserInputType === 'input' ?
              'Benutzer wählen'
            : 'E-Mail eingeben'}</LinkButton
          >
        {/if}

        {#if form.email.visible}
          <TextInput
            errorMsg={form.email.error}
            id="login-email"
            label="E-Mail"
            type="text"
            bind:value={form.email.value}
            onchange={formActions.handleEmailChange}
            oninput={formActions.handleEmailInput}
          />
        {/if}

        {#if form.userSelection.visible}
          <DropDownLogin
            label="Benutzer auswählen"
            selected={form.userSelection?.value}
            onValueChange={(v) => {
              form.userSelection!.value = v;
            }}
            items={form.userSelection?.options ?? []}
            errorMsg={form.userSelection?.error}
          ></DropDownLogin>
        {/if}
      </VStack>
      {#if form.password.visible}
        <TextInput
          id="login-password"
          label="Passwort"
          type="password"
          value={form.password.value}
          oninput={formActions.handlePasswordInput}
          onchange={formActions.handlePasswordChange}
          errorMsg={form.password.error}
        />
      {/if}

      <VStack gap={4} xalign="center">
        {#if form.formError}
          <p class="px-4 text-center font-sans text-xs font-normal text-c-error" role="alert">
            {form.formError}
          </p>
        {/if}
        <CtaButton type="submit" loading={form.loading} class="self-stretch"
          >{form.labels.submitLabel}
        </CtaButton>
        {#if form.email.visible}
          <LinkButton type="button" highlight onclick={() => formActions.toggleMode()}>
            {form.labels.switchModeLabel}
          </LinkButton>
        {/if}
      </VStack>
    </VStack>
  </form>
</VStack>
